import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7073/Campaigns";
	}
	addOrUpdateDocument(e, t, r, i, a) {
		let o = this.baseUrl + "/AddOrUpdateDocument";
		if (o += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (o += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'documentType' must be defined and cannot be null.");
		o += "documentType=" + encodeURIComponent(f(t)) + "&", r != null && (o += "contractId=" + encodeURIComponent(f(r)) + "&"), i != null && (o += "filePath=" + encodeURIComponent(f(i)) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "POST",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processAddOrUpdateDocument(e)));
	}
	processAddOrUpdateDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	beginCampaign(e, t) {
		let r = this.baseUrl + "/BeginCampaign", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processBeginCampaign(e)));
	}
	processBeginCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	completeCampaignStep(e, t) {
		let r = this.baseUrl + "/CompleteCampaignStep", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCompleteCampaignStep(e)));
	}
	processCompleteCampaignStep(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	constructConditionClauseText(e, t) {
		let r = this.baseUrl + "/ConstructConditionClauseText", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processConstructConditionClauseText(e)));
	}
	processConstructConditionClauseText(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	devCreateContractTestCampaign(e, t) {
		let r = this.baseUrl + "/DevCreateContractTestCampaign", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDevCreateContractTestCampaign(e)));
	}
	processDevCreateContractTestCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	exchangeContract(e, t) {
		let r = this.baseUrl + "/ExchangeContract", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processExchangeContract(e)));
	}
	processExchangeContract(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	formsByLocations(e) {
		let t = this.baseUrl + "/FormsByLocations", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processFormsByLocations(e)));
	}
	processFormsByLocations(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	generateEventSubscriptions(e) {
		let t = this.baseUrl + "/GenerateEventSubscriptions", r = {
			method: "POST",
			url: t,
			headers: {},
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGenerateEventSubscriptions(e)));
	}
	processGenerateEventSubscriptions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 || e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getActiveCampaigns(e) {
		let t = this.baseUrl + "/GetActiveCampaigns", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetActiveCampaigns(e)));
	}
	processGetActiveCampaigns(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getArchivedCampaignsByAdmin(e, t) {
		let r = this.baseUrl + "/GetArchivedCampaignsByAdmin";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetArchivedCampaignsByAdmin(e)));
	}
	processGetArchivedCampaignsByAdmin(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getArchivedCampaignsByAgency(e) {
		let t = this.baseUrl + "/GetArchivedCampaignsByAgency", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetArchivedCampaignsByAgency(e)));
	}
	processGetArchivedCampaignsByAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCampaign(e, t) {
		let r = this.baseUrl + "/GetCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCampaign(e)));
	}
	processGetCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCampaignsForAgency(e, t) {
		let r = this.baseUrl + "/GetCampaignsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCampaignsForAgency(e)));
	}
	processGetCampaignsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getSpecialConditionBank(e) {
		let t = this.baseUrl + "/GetSpecialConditionBank", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetSpecialConditionBank(e)));
	}
	processGetSpecialConditionBank(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUploadedFileLink(e, t) {
		let r = this.baseUrl + "/GetUploadedFileLink";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		r += "filePath=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	loadForm(e, t, r) {
		let i = this.baseUrl + "/LoadForm";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'formId' must be defined and cannot be null.");
		i += "formId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processLoadForm(e)));
	}
	processLoadForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	negotiate(e) {
		let t = this.baseUrl + "/Negotiate", r = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processNegotiate(e)));
	}
	processNegotiate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	performCampaignAction(e, t) {
		let r = this.baseUrl + "/PerformCampaignAction", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPerformCampaignAction(e)));
	}
	processPerformCampaignAction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	performContractAction(e, t) {
		let r = this.baseUrl + "/PerformContractAction", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPerformContractAction(e)));
	}
	processPerformContractAction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeFile(e, t) {
		let r = this.baseUrl + "/RemoveFile", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeFormSubmission(e, t) {
		let r = this.baseUrl + "/RemoveFormSubmission", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveFormSubmission(e)));
	}
	processRemoveFormSubmission(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	saveForm(e, t) {
		let r = this.baseUrl + "/SaveForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSaveForm(e)));
	}
	processSaveForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	sendForm(e, t) {
		let r = this.baseUrl + "/SendForm", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSendForm(e)));
	}
	processSendForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	setCampaignOwnership(e, t) {
		let r = this.baseUrl + "/SetCampaignOwnership", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetCampaignOwnership(e)));
	}
	processSetCampaignOwnership(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffBeginCampaign(e, t) {
		let r = this.baseUrl + "/StaffBeginCampaign", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffBeginCampaign(e)));
	}
	processStaffBeginCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateContractDepositRelease(e, t, r, i) {
		let a = this.baseUrl + "/StaffCreateContractDepositRelease";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffCreateContractDepositRelease(e)));
	}
	processStaffCreateContractDepositRelease(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 || e.status === 409 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAgreementDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetAgreementDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAgreementDetailsForCampaign(e)));
	}
	processStaffGetAgreementDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBlankContractDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetBlankContractDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBlankContractDetailsForCampaign(e)));
	}
	processStaffGetBlankContractDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBuyers(e, t) {
		let r = this.baseUrl + "/StaffGetBuyers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBuyers(e)));
	}
	processStaffGetBuyers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBuyersAgent(e, t) {
		let r = this.baseUrl + "/StaffGetBuyersAgent";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBuyersAgent(e)));
	}
	processStaffGetBuyersAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetBuyersSolicitor(e, t) {
		let r = this.baseUrl + "/StaffGetBuyersSolicitor";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetBuyersSolicitor(e)));
	}
	processStaffGetBuyersSolicitor(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetCampaign(e)));
	}
	processStaffGetCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCampaignDashboard(e, t, r, i, a, o, s, c, l, u, d) {
		let p = this.baseUrl + "/StaffGetCampaignDashboard";
		if (p += "?", e != null) for (let t of e) p += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		if (t != null) for (let e of t) p += "states=" + encodeURIComponent(f(e)) + "&";
		if (r != null) for (let e of r) p += "campaignStatuses=" + encodeURIComponent(f(e)) + "&";
		if (i != null) for (let e of i) p += "launchDateStatuses=" + encodeURIComponent(f(e)) + "&";
		if (a != null) for (let e of a) p += "marketingStatuses=" + encodeURIComponent(f(e)) + "&";
		if (o != null) for (let e of o) p += "blankContractStatuses=" + encodeURIComponent(f(e)) + "&";
		s != null && (p += "addressSearch=" + encodeURIComponent(f(s)) + "&"), c != null && (p += "continuationToken=" + encodeURIComponent(f(c)) + "&"), l != null && (p += "pageSize=" + encodeURIComponent(f(l)) + "&"), u != null && (p += "sortingOption=" + encodeURIComponent(f(u)) + "&"), p = p.replace(/[?&]$/, "");
		let m = {
			method: "GET",
			url: p,
			headers: { Accept: "application/json" },
			signal: d
		};
		return this.transformOptions(m).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(p, e, (e) => this.processStaffGetCampaignDashboard(e)));
	}
	processStaffGetCampaignDashboard(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCampaignOverview(e, t) {
		let r = this.baseUrl + "/StaffGetCampaignOverview";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetCampaignOverview(e)));
	}
	processStaffGetCampaignOverview(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetCommissionInfoForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetCommissionInfoForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetCommissionInfoForCampaign(e)));
	}
	processStaffGetCommissionInfoForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContract(e, t) {
		let r = this.baseUrl + "/StaffGetContract";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		r += "contractId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContract(e)));
	}
	processStaffGetContract(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractDashboard(e, t, r, i, a, o, s, c) {
		let l = this.baseUrl + "/StaffGetContractDashboard";
		if (l += "?", e != null) for (let t of e) l += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		if (t != null) for (let e of t) l += "states=" + encodeURIComponent(f(e)) + "&";
		if (r != null) for (let e of r) l += "contractStatuses=" + encodeURIComponent(f(e)) + "&";
		if (i != null) for (let e of i) l += "settlementDateStatuses=" + encodeURIComponent(f(e)) + "&";
		if (a != null) for (let e of a) l += "vendorBankDetailsStatuses=" + encodeURIComponent(f(e)) + "&";
		o != null && (l += "addressSearch=" + encodeURIComponent(f(o)) + "&"), s != null && (l += "sortingOptionContractDashboard=" + encodeURIComponent(f(s)) + "&"), l = l.replace(/[?&]$/, "");
		let u = {
			method: "GET",
			url: l,
			headers: { Accept: "application/json" },
			signal: c
		};
		return this.transformOptions(u).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(l, e, (e) => this.processStaffGetContractDashboard(e)));
	}
	processStaffGetContractDashboard(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractDates(e, t, r) {
		let i = this.baseUrl + "/StaffGetContractDates";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetContractDates(e)));
	}
	processStaffGetContractDates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractDeposits(e, t, r) {
		let i = this.baseUrl + "/StaffGetContractDeposits";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetContractDeposits(e)));
	}
	processStaffGetContractDeposits(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractSettlement(e, t, r) {
		let i = this.baseUrl + "/StaffGetContractSettlement";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetContractSettlement(e)));
	}
	processStaffGetContractSettlement(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetContractsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetContractsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetContractsForCampaign(e)));
	}
	processStaffGetContractsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetDocumentsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetDocumentsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetDocumentsForCampaign(e)));
	}
	processStaffGetDocumentsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetExternalConjunction(e, t) {
		let r = this.baseUrl + "/StaffGetExternalConjunction";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetExternalConjunction(e)));
	}
	processStaffGetExternalConjunction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetFormConfiguration(e, t) {
		let r = this.baseUrl + "/StaffGetFormConfiguration", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetFormConfiguration(e)));
	}
	processStaffGetFormConfiguration(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetLaunchDateDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetLaunchDateDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetLaunchDateDetailsForCampaign(e)));
	}
	processStaffGetLaunchDateDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPhotosAndMediaDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetPhotosAndMediaDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffGetPhotosAndMediaDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPropertyDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetPropertyDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPropertyDetailsForCampaign(e)));
	}
	processStaffGetPropertyDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPropertyInformationProgressForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetPropertyInformationProgressForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPropertyInformationProgressForCampaign(e)));
	}
	processStaffGetPropertyInformationProgressForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetSaleInformation(e, t, r) {
		let i = this.baseUrl + "/StaffGetSaleInformation";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetSaleInformation(e)));
	}
	processStaffGetSaleInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetSpecialConditions(e, t, r) {
		let i = this.baseUrl + "/StaffGetSpecialConditions";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", t != null && (i += "contractId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetSpecialConditions(e)));
	}
	processStaffGetSpecialConditions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetTenancyInformationForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetTenancyInformationForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetTenancyInformationForCampaign(e)));
	}
	processStaffGetTenancyInformationForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetUploadedFileLink(e, t) {
		let r = this.baseUrl + "/StaffGetUploadedFileLink";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		r += "filePath=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "text/plain" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetUploadedFileLink(e)));
	}
	processStaffGetUploadedFileLink(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetVendorDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffGetVendorDetailsForCampaign";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetVendorDetailsForCampaign(e)));
	}
	processStaffGetVendorDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffPreviewLinkedDates(e, t, r, i) {
		let a = this.baseUrl + "/StaffPreviewLinkedDates";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffPreviewLinkedDates(e)));
	}
	processStaffPreviewLinkedDates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSaveForm(e, t) {
		let r = this.baseUrl + "/StaffSaveForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSaveForm(e)));
	}
	processStaffSaveForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSearchForCampaign(e, t, r, i) {
		let a = this.baseUrl + "/StaffSearchForCampaign";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'searchTerm' must be defined and cannot be null.");
		if (a += "searchTerm=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'searchForArchived' must be defined and cannot be null.");
		a += "searchForArchived=" + encodeURIComponent(f(t)) + "&", r != null && (a += "continuationToken=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffSearchForCampaign(e)));
	}
	processStaffSearchForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSubmitForm(e, t) {
		let r = this.baseUrl + "/StaffSubmitForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSubmitForm(e)));
	}
	processStaffSubmitForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateAgreementDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateAgreementDetailsForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateAgreementDetailsForCampaign(e)));
	}
	processStaffUpdateAgreementDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBlankContractDetailsForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBlankContractDetailsForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBlankContractDetailsForCampaign(e)));
	}
	processStaffUpdateBlankContractDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBuyers(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBuyers";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBuyers(e)));
	}
	processStaffUpdateBuyers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBuyersAgent(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBuyersAgent";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBuyersAgent(e)));
	}
	processStaffUpdateBuyersAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateBuyersSolicitor(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateBuyersSolicitor";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateBuyersSolicitor(e)));
	}
	processStaffUpdateBuyersSolicitor(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateCommissionInfoForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateCommissionInfoForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateCommissionInfoForCampaign(e)));
	}
	processStaffUpdateCommissionInfoForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractComplianceFields(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractComplianceFields";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractComplianceFields(e)));
	}
	processStaffUpdateContractComplianceFields(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractDates(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractDates";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractDates(e)));
	}
	processStaffUpdateContractDates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractDeposits(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractDeposits";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractDeposits(e)));
	}
	processStaffUpdateContractDeposits(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractSettlement(e, t, r, i) {
		let a = this.baseUrl + "/StaffUpdateContractSettlement";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffUpdateContractSettlement(e)));
	}
	processStaffUpdateContractSettlement(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractSpecialConditionDueDate(e, t) {
		let r = this.baseUrl + "/StaffUpdateContractSpecialConditionDueDate", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateContractSpecialConditionDueDate(e)));
	}
	processStaffUpdateContractSpecialConditionDueDate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractSpecialConditions(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateContractSpecialConditions";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		i += "contractId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateContractSpecialConditions(e)));
	}
	processStaffUpdateContractSpecialConditions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateContractTermination(e, t, r, i) {
		let a = this.baseUrl + "/StaffUpdateContractTermination";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffUpdateContractTermination(e)));
	}
	processStaffUpdateContractTermination(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of StaffUpdateModel", e.status, e.data, t, e.data) : e.status === 403 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateExternalConjunction(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateExternalConjunction";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateExternalConjunction(e)));
	}
	processStaffUpdateExternalConjunction(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateLaunchDateForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateLaunchDateForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateLaunchDateForCampaign(e)));
	}
	processStaffUpdateLaunchDateForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdatePhotosAndMediaDetailsForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdatePhotosAndMediaDetailsForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdatePhotosAndMediaDetailsForCampaign(e)));
	}
	processStaffUpdatePhotosAndMediaDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdatePropertyDetailsForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdatePropertyDetailsForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdatePropertyDetailsForCampaign(e)));
	}
	processStaffUpdatePropertyDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateSaleInformation(e, t, r, i) {
		let a = this.baseUrl + "/StaffUpdateSaleInformation";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (a += "campaignId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'contractId' must be defined and cannot be null.");
		a += "contractId=" + encodeURIComponent(f(t)) + "&", a = a.replace(/[?&]$/, "");
		let o = JSON.stringify(r), s = {
			method: "POST",
			url: a,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: o,
			signal: i
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffUpdateSaleInformation(e)));
	}
	processStaffUpdateSaleInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateServiceFeeInfoForCampaign(e, t) {
		let r = this.baseUrl + "/StaffUpdateServiceFeeInfoForCampaign", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateServiceFeeInfoForCampaign(e)));
	}
	processStaffUpdateServiceFeeInfoForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateTenancyInformationForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateTenancyInformationForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateTenancyInformationForCampaign(e)));
	}
	processStaffUpdateTenancyInformationForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateVendorDetailsForCampaign(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateVendorDetailsForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateVendorDetailsForCampaign(e)));
	}
	processStaffUpdateVendorDetailsForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	submitForm(e, t) {
		let r = this.baseUrl + "/SubmitForm", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSubmitForm(e)));
	}
	processSubmitForm(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.NoAdjustment = "NoAdjustment", e.YesAdjustment = "YesAdjustment", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Exclusive = "Exclusive", e.Open = "Open", e.Sole = "Sole", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Information = "Information", e.Action = "Action", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.And = "And", e.Or = "Or", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Offline = "Offline", e.Live = "Live", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.None = "None", e.CompanyManaged = "CompanyManaged", e.SelfManaged = "SelfManaged", e.NonFunctioning = "NonFunctioning", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Restore = "Restore", e.RevertToCurrent = "RevertToCurrent", e.MarkAsUnderContract = "MarkAsUnderContract", e.MarkAsSold = "MarkAsSold", e.Archive = "Archive", e.Withdraw = "Withdraw", e;
}({}), ne = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), re = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), ie = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ae = /* @__PURE__ */ function(e) {
	return e.Archived = "Archived", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), oe = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), se = /* @__PURE__ */ function(e) {
	return e.AwaitingFunds = "AwaitingFunds", e.PayLaterApplicationSigned = "PayLaterApplicationSigned", e.Paid = "Paid", e.Cancelled = "Cancelled", e.PendingSettlement = "PendingSettlement", e.Complete = "Complete", e.Withdrawn = "Withdrawn", e.PayLaterDeclined = "PayLaterDeclined", e.Draft = "Draft", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.PendingCompliance = "PendingCompliance", e.Current = "Current", e.UnderContract = "UnderContract", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Blinds = "Blinds", e.Curtains = "Curtains", e.InsectScreens = "InsectScreens", e.Stove = "Stove", e.RangeHood = "RangeHood", e.FixedFloorCoverings = "FixedFloorCoverings", e.SolarPanels = "SolarPanels", e.BuiltInWardrobes = "BuiltInWardrobes", e.Dishwasher = "Dishwasher", e.LightFittings = "LightFittings", e.PoolEquipment = "PoolEquipment", e.ClothesLine = "ClothesLine", e.TVAntenna = "TVAntenna", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.Flat = "Flat", e.Tiered = "Tiered", e.VendorChoice = "VendorChoice", e.Other = "Other", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Search = "Search", e.Manual = "Manual", e.AttachAsFile = "AttachAsFile", e.NotAvailable = "NotAvailable", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.OnDate = "OnDate", e.NdaysFromDate = "NdaysFromDate", e.OnSpecificDate = "OnSpecificDate", e.UponSatisfactionOfSpecialCondition = "UponSatisfactionOfSpecialCondition", e.AdditionalReason = "AdditionalReason", e.NotApplicable = "NotApplicable", e.NotSubjectToFinance = "NotSubjectToFinance", e.Other = "Other", e.AsPerContract = "AsPerContract", e.BuildingAndPestBeingSatisfied = "BuildingAndPestBeingSatisfied", e.FinanceBeingSatisfied = "FinanceBeingSatisfied", e.OnCoolingOffDate = "OnCoolingOffDate", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Finance = "Finance", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Email = "Email", e.Phone = "Phone", e.Currency = "Currency", e.TextArea = "TextArea", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.RevertToAccepted = "RevertToAccepted", e.RevertToUnconditional = "RevertToUnconditional", e.MarkAsAwaitingExchange = "MarkAsAwaitingExchange", e.MarkAsAccepted = "MarkAsAccepted", e.MarkAsUnconditional = "MarkAsUnconditional", e.MarkSettled = "MarkSettled", e.Terminated = "Terminated", e.Cancelled = "Cancelled", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.SalesAdvice = "SalesAdvice", e.ContractExchange = "ContractExchange", e;
}({}), H = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), U = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e;
}({}), W = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e;
}({}), G = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.AwaitingInitialDeposit = "AwaitingInitialDeposit", e.AwaitingAdditionalDeposit = "AwaitingAdditionalDeposit", e.FullyReleased = "FullyReleased", e.Ineligible = "Ineligible", e;
}({}), K = /* @__PURE__ */ function(e) {
	return e.PendingSolicitorExchange = "PendingSolicitorExchange", e.PendingAgentExchange = "PendingAgentExchange", e.PendingCompliance = "PendingCompliance", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e.Settled = "Settled", e.Terminated = "Terminated", e;
}({}), ce = /* @__PURE__ */ function(e) {
	return e.HouseAndLand = "HouseAndLand", e.CommunityTitles = "CommunityTitles", e.NewContract2025 = "NewContract2025", e;
}({}), le = /* @__PURE__ */ function(e) {
	return e.IncludeShorteningOfCoolingOff = "IncludeShorteningOfCoolingOff", e.IncludeWaiverOfCoolingOff = "IncludeWaiverOfCoolingOff", e;
}({}), ue = /* @__PURE__ */ function(e) {
	return e.FiveDays = "FiveDays", e.TenDays = "TenDays", e.NDays = "NDays", e.NoCoolingOff = "NoCoolingOff", e;
}({}), de = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), fe = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.BusinessDays = "BusinessDays", e;
}({}), pe = /* @__PURE__ */ function(e) {
	return e.On = "On", e.NDaysFrom = "NDaysFrom", e;
}({}), me = /* @__PURE__ */ function(e) {
	return e.PartialDepositPaidUpfront = "PartialDepositPaidUpfront", e.FullDepositPaidUpfront = "FullDepositPaidUpfront", e;
}({}), he = /* @__PURE__ */ function(e) {
	return e.Initial = "Initial", e.Balance = "Balance", e;
}({}), ge = /* @__PURE__ */ function(e) {
	return e.DocuSign = "DocuSign", e.UploadedManually = "UploadedManually", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.None = "None", e.BlankPrepared = "BlankPrepared", e.ContractSubmitted = "ContractSubmitted", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.None = "None", e.Finance = "Finance", e.BuildingAndPest = "BuildingAndPest", e.BodyCorporate = "BodyCorporate", e.CoolingOff = "CoolingOff", e.SeveralSpecialConditions = "SeveralSpecialConditions", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.AgentPortal = "AgentPortal", e.UploadedManually = "UploadedManually", e;
}({}), be = /* @__PURE__ */ function(e) {
	return e.NewContract = "NewContract", e.Accepted = "Accepted", e.Unconditional = "Unconditional", e;
}({}), xe = /* @__PURE__ */ function(e) {
	return e.RPDataSearch = "RPDataSearch", e.ManualAddress = "ManualAddress", e;
}({}), Se = /* @__PURE__ */ function(e) {
	return e.Standard = "Standard", e.ExceedsTenPercent = "ExceedsTenPercent", e.EarlyRelease = "EarlyRelease", e;
}({}), Ce = /* @__PURE__ */ function(e) {
	return e.OffMarket = "OffMarket", e.LaunchScheduled = "LaunchScheduled", e;
}({}), we = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Te = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), Ee = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), De = /* @__PURE__ */ function(e) {
	return e.FullEdit = "FullEdit", e.PartialEdit = "PartialEdit", e.ReadOnly = "ReadOnly", e;
}({}), Oe = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), ke = /* @__PURE__ */ function(e) {
	return e.Signature = "Signature", e.SignatureAndDate = "SignatureAndDate", e.Text = "Text", e.Checkbox = "Checkbox", e.Initial = "Initial", e;
}({}), Ae = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), je = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Me = /* @__PURE__ */ function(e) {
	return e.AdditionalDocumentations = "AdditionalDocumentations", e.AddressSearch = "AddressSearch", e.BuyersAgentSearch = "BuyersAgentSearch", e.AgreementDetails = "AgreementDetails", e.BuildingAndPest = "BuildingAndPest", e.VendorBuyerDetails = "VendorBuyerDetails", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.ContractDeposit = "ContractDeposit", e.DepositPayable = "DepositPayable", e.Dropdown = "Dropdown", e.Date = "Date", e.DateTime = "DateTime", e.TextInput = "TextInput", e.Radio = "Radio", e.InfoLabel = "InfoLabel", e.PropertySearch = "PropertySearch", e.SolicitorSearch = "SolicitorSearch", e.ListingAgentSelector = "ListingAgentSelector", e.Commission = "Commission", e.PersonName = "PersonName", e.Checkbox = "Checkbox", e.MarketingPackage = "MarketingPackage", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.ReviewAndSign = "ReviewAndSign", e.AlternateAddressSearch = "AlternateAddressSearch", e.FileUpload = "FileUpload", e.TenantedProperty = "TenantedProperty", e.TypedDocumentUpload = "TypedDocumentUpload", e.POADocumentUpload = "POADocumentUpload", e.TextArea = "TextArea", e.SaleDetails = "SaleDetails", e.LaunchDetails = "LaunchDetails", e.SpecialConditions = "SpecialConditions", e.YesNoQuestion = "YesNoQuestion", e.SettlementDate = "SettlementDate", e.SendForDocuSigning = "SendForDocuSigning", e.SignboardRemoval = "SignboardRemoval", e.MarketingContributions = "MarketingContributions", e.DisplayPrice = "DisplayPrice", e.PriceSpecification = "PriceSpecification", e.Currency = "Currency", e.SubjectToFinance = "SubjectToFinance", e.AdjustmentToCommission = "AdjustmentToCommission", e.ExternalConjunction = "ExternalConjunction", e.PropertyType = "PropertyType", e.VendorDetailsDisplay = "VendorDetailsDisplay", e.ConditionalTextInput = "ConditionalTextInput", e.SecondaryAgentCommissionSplit = "SecondaryAgentCommissionSplit", e.TenancyDetails = "TenancyDetails", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.LegalDescription = "LegalDescription", e.PropertyAttributes = "PropertyAttributes", e.ChattelsIncluded = "ChattelsIncluded", e.RuralParticulars = "RuralParticulars", e.PriceOpinion = "PriceOpinion", e.EditablePdfUpload = "EditablePdfUpload", e.Deposit = "Deposit", e.CoolingOffPeriod = "CoolingOffPeriod", e.Image = "Image", e.Alerts = "Alerts", e.MarketingConfirmation = "MarketingConfirmation", e.MarketingLaunchDetails = "MarketingLaunchDetails", e.SellersDisclosurePreparedBy = "SellersDisclosurePreparedBy", e.BodyCorporate = "BodyCorporate", e.SellersDisclosureUpload = "SellersDisclosureUpload", e.CommunityTitlesScheme = "CommunityTitlesScheme", e.BodyCorporateRecords = "BodyCorporateRecords", e.SurveyPlanUpload = "SurveyPlanUpload", e.IdentityVerificationExports = "IdentityVerificationExports", e;
}({}), Ne = /* @__PURE__ */ function(e) {
	return e.Employee = "Employee", e.SelfEmployed = "SelfEmployed", e.Unemployed = "Unemployed", e;
}({}), Pe = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), Fe = /* @__PURE__ */ function(e) {
	return e.Manual = "Manual", e.DocuSign = "DocuSign", e.Email = "Email", e;
}({}), Ie = /* @__PURE__ */ function(e) {
	return e.Created = "Created", e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.Bounced = "Bounced", e;
}({}), Le = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), Re = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), ze = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), Be = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Ve = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Staff = "Staff", e;
}({}), He = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Ue = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), We = /* @__PURE__ */ function(e) {
	return e.None = "None", e.ForwardAndBack = "ForwardAndBack", e.BackAndReview = "BackAndReview", e.BackAndSubmit = "BackAndSubmit", e.Forward = "Forward", e;
}({}), Ge = /* @__PURE__ */ function(e) {
	return e.Send = "Send", e.GeneratePdf = "GeneratePdf", e;
}({}), Ke = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), qe = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Je = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), Ye = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), Xe = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), Ze = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), Qe = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), $e = /* @__PURE__ */ function(e) {
	return e.Incomplete = "Incomplete", e.Complete = "Complete", e;
}({}), et = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), tt = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), nt = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), rt = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), it = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), at = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), ot = /* @__PURE__ */ function(e) {
	return e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e.LaunchDateNotSet = "LaunchDateNotSet", e.OffMarket = "OffMarket", e;
}({}), st = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), ct = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), lt = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), ut = /* @__PURE__ */ function(e) {
	return e.Paid = "Paid", e.AwaitingFunds = "AwaitingFunds", e;
}({}), dt = /* @__PURE__ */ function(e) {
	return e.Waived = "Waived", e.Exempt = "Exempt", e;
}({}), ft = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), pt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), mt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), ht = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), gt = /* @__PURE__ */ function(e) {
	return e.EQ = "EQ", e.NEQ = "NEQ", e.LT = "LT", e.GT = "GT", e.LTEQ = "LTEQ", e.GTEQ = "GTEQ", e;
}({}), _t = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), vt = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), yt = /* @__PURE__ */ function(e) {
	return e.JointTenants = "JointTenants", e.TenantsInCommon = "TenantsInCommon", e.Trustee = "Trustee", e.SoleProprietor = "SoleProprietor", e;
}({}), bt = /* @__PURE__ */ function(e) {
	return e.Complete = "Complete", e.Future = "Future", e.FutureDisabled = "FutureDisabled", e.Invalid = "Invalid", e;
}({}), xt = /* @__PURE__ */ function(e) {
	return e.Australia = "Australia", e.NewSouthWales = "NewSouthWales", e.Other = "Other", e.Queensland = "Queensland", e.Victoria = "Victoria", e.NorthernTerritory = "NorthernTerritory", e.SouthAustralia = "SouthAustralia", e.WesternAustralia = "WesternAustralia", e.AustralianCapitalTerritory = "AustralianCapitalTerritory", e.Tasmania = "Tasmania", e;
}({}), St = /* @__PURE__ */ function(e) {
	return e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.NoPoolCertificate = "NoPoolCertificate", e;
}({}), Ct = /* @__PURE__ */ function(e) {
	return e.NoPool = "NoPool", e.PoolSafetyCertificate = "PoolSafetyCertificate", e.BuildingCertificate = "BuildingCertificate", e.Form36 = "Form36", e;
}({}), wt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Tt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Et = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Dt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ot = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), kt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), At = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), jt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Mt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Nt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Pt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ft = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), It = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Lt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Rt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), zt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Bt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Vt = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Ht = /* @__PURE__ */ function(e) {
	return e.Downsizing = "Downsizing", e.Upsizing = "Upsizing", e.Relocating = "Relocating", e.Other = "Other", e;
}({}), Ut = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), Wt = /* @__PURE__ */ function(e) {
	return e.Weekly = "Weekly", e.Fortnightly = "Fortnightly", e.Monthly = "Monthly", e;
}({}), Gt = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), Kt = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), qt = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Jt = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), Yt = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), Xt = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), Zt = /* @__PURE__ */ function(e) {
	return e.VendorSolicitor = "VendorSolicitor", e.Agent = "Agent", e.ThirdParty = "ThirdParty", e.Exempt = "Exempt", e;
}({}), Qt = /* @__PURE__ */ function(e) {
	return e.None = "None", e.SellersDisclosureFields = "SellersDisclosureFields", e;
}({}), $t = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), en = /* @__PURE__ */ function(e) {
	return e.SendForDocuSigning = "SendForDocuSigning", e.EmailToAgent = "EmailToAgent", e;
}({}), tn = /* @__PURE__ */ function(e) {
	return e.ListingGenerator = "ListingGenerator", e.ContractRequest = "ContractRequest", e.ContractSubmission = "ContractSubmission", e.ListingSubmission = "ListingSubmission", e.BlankContract = "BlankContract", e.ContractExchange = "ContractExchange", e.MarketingPackageGenerator = "MarketingPackageGenerator", e.MarketingPackageSubmission = "MarketingPackageSubmission", e.ListingLaunch = "ListingLaunch", e;
}({}), nn = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), rn = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), an = /* @__PURE__ */ function(e) {
	return e.SettlementDateSet = "SettlementDateSet", e.NoDateSet = "NoDateSet", e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e;
}({}), on = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), sn = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), cn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), ln = /* @__PURE__ */ function(e) {
	return e.Other = "Other", e.ToBeAdvised = "ToBeAdvised", e;
}({}), un = /* @__PURE__ */ function(e) {
	return e.LaunchDateAsc = "LaunchDateAsc", e.LaunchDateDesc = "LaunchDateDesc", e;
}({}), dn = /* @__PURE__ */ function(e) {
	return e.SettlementDateAsc = "SettlementDateAsc", e.SettlementDateDesc = "SettlementDateDesc", e;
}({}), fn = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), pn = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), mn = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), hn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.VendorSolicitor = "VendorSolicitor", e.Other = "Other", e;
}({}), gn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.VendorSolicitor = "VendorSolicitor", e.Other = "Other", e;
}({}), _n = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), vn = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), yn = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), bn = /* @__PURE__ */ function(e) {
	return e.Pexa = "Pexa", e.InPerson = "InPerson", e;
}({}), xn = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Sn = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e.DoNotUpdate = "DoNotUpdate", e;
}({}), Cn = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), wn = /* @__PURE__ */ function(e) {
	return e.ContractDate = "ContractDate", e.FinanceDate = "FinanceDate", e.BuildingAndPestDate = "BuildingAndPestDate", e.ContractConditionChanges = "ContractConditionChanges", e.SpecialConditionDate = "SpecialConditionDate", e;
}({}), Tn = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Final = "Final", e;
}({}), En = /* @__PURE__ */ function(e) {
	return e.AgentSpecified = "AgentSpecified", e.CommissionReduction = "CommissionReduction", e.Other = "Other", e.VendorChoiceConfirmed = "VendorChoiceConfirmed", e;
}({}), Dn = /* @__PURE__ */ function(e) {
	return e.Pexa = "Pexa", e.InPerson = "InPerson", e;
}({}), On = /* @__PURE__ */ function(e) {
	return e.CoolingOffPeriod = "CoolingOffPeriod", e.FailedFinance = "FailedFinance", e.FailedBuildingAndPest = "FailedBuildingAndPest", e.SpecialConditions = "SpecialConditions", e;
}({}), kn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.NoDepositReceived = "NoDepositReceived", e;
}({}), An = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.Confirmed = "Confirmed", e.OffMarket = "OffMarket", e;
}({}), jn = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), Mn = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e.DoNotUpdate = "DoNotUpdate", e;
}({}), Nn = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), Pn = /* @__PURE__ */ function(e) {
	return e.UrbanXError = "UrbanXError", e.FreeSale = "FreeSale", e.Other = "Other", e;
}({}), Fn = /* @__PURE__ */ function(e) {
	return e.Vendor = "Vendor", e.Buyer = "Buyer", e.Agent = "Agent", e.Approver = "Approver", e.BuyerSolicitor = "BuyerSolicitor", e.VendorSolicitor = "VendorSolicitor", e;
}({}), In = /* @__PURE__ */ function(e) {
	return e.Act = "Act", e.Nsw = "Nsw", e.Nt = "Nt", e.Qld = "Qld", e.Sa = "Sa", e.Tas = "Tas", e.Wa = "Wa", e.Vic = "Vic", e;
}({}), Ln = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Rn = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), zn = /* @__PURE__ */ function(e) {
	return e.Fixed = "Fixed", e.Periodic = "Periodic", e;
}({}), Bn = /* @__PURE__ */ function(e) {
	return e.NotTenanted = "NotTenanted", e.TenantedAgencyManaged = "TenantedAgencyManaged", e.TenantedSelfManaged = "TenantedSelfManaged", e.Unknown = "Unknown", e.TenantedAgencyManagedHolidayRental = "TenantedAgencyManagedHolidayRental", e;
}({}), Vn = /* @__PURE__ */ function(e) {
	return e.SingleRate = "SingleRate", e.MultiRate = "MultiRate", e;
}({}), Hn = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.Weeks = "Weeks", e.Months = "Months", e.Years = "Years", e;
}({}), Un = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Wn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Gn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Kn = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Docusign = "Docusign", e;
}({}), qn = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), Jn = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), Yn = /* @__PURE__ */ function(e) {
	return e.Outstanding = "Outstanding", e.Complete = "Complete", e.Na = "Na", e;
}({}), Xn = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), Zn = /* @__PURE__ */ function(e) {
	return e.Individual = "Individual", e.PowerOfAttorney = "PowerOfAttorney", e.Company = "Company", e.DeceasedEstate = "DeceasedEstate", e;
}({}), Qn = /* @__PURE__ */ function(e) {
	return e.Together = "Together", e.Separately = "Separately", e;
}({}), $n = /* @__PURE__ */ function(e) {
	return e.InPerson = "InPerson", e.Biometric = "Biometric", e.NoPhotoId = "NoPhotoId", e;
}({}), er = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), q = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCampaignsApiException = !0;
	static isCampaignsApiException(e) {
		return e.isCampaignsApiException === !0;
	}
};
function J(e, t, n, r, i) {
	throw i ?? new q(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var Y = "campaigns";
function tr(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var X = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), tr(r);
}, nr = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[Y] || `${e}/${Y}`;
}, Z = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = nr(i), u = c, d = X(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(X(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, Q = a({}), rr = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Z(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(Q.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, ir = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, documentType: n, contractId: r, filePath: i } = e;
		return a.addOrUpdateDocument(t, n, r, i);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		addOrUpdateDocument: u,
		addOrUpdateDocumentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ar = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.beginCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		beginCampaign: u,
		beginCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, or = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.completeCampaignStep(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		completeCampaignStep: u,
		completeCampaignStepPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, sr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.constructConditionClauseText(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		constructConditionClauseText: u,
		constructConditionClauseTextPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, cr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.devCreateContractTestCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		devCreateContractTestCampaign: u,
		devCreateContractTestCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, lr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.exchangeContract(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		exchangeContract: u,
		exchangeContractPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ur = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async () => a.formsByLocations(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		formsByLocations: u,
		formsByLocationsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, dr = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getActiveCampaigns"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getActiveCampaigns(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, fr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getActiveCampaigns"] });
	}, e[0] = t, e[1] = n), n;
}, pr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getArchivedCampaignsByAdmin", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getArchivedCampaignsByAdmin(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, mr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAdmin", e] });
	}, e[0] = t, e[1] = n), n;
}, hr = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getArchivedCampaignsByAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getArchivedCampaignsByAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, gr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getArchivedCampaignsByAgency"] });
	}, e[0] = t, e[1] = n), n;
}, _r = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, vr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, yr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaignsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaignsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, br = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaignsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, xr = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(Q), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getSpecialConditionBank"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getSpecialConditionBank(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Sr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getSpecialConditionBank"] });
	}, e[0] = t, e[1] = n), n;
}, Cr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, wr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, Tr = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"loadForm",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.loadForm(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Er = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"loadForm",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Dr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async () => a.negotiate(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		negotiate: u,
		negotiatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Or = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.performCampaignAction(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		performCampaignAction: u,
		performCampaignActionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, kr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.performContractAction(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		performContractAction: u,
		performContractActionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ar = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFile(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFile: u,
		removeFilePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, jr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.removeFormSubmission(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		removeFormSubmission: u,
		removeFormSubmissionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Mr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.saveForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		saveForm: u,
		saveFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Nr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.sendForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		sendForm: u,
		sendFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Pr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setCampaignOwnership(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setCampaignOwnership: u,
		setCampaignOwnershipPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Fr = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffBeginCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffBeginCampaign: u,
		staffBeginCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ir = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffCreateContractDepositRelease(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffCreateContractDepositRelease: u,
		staffCreateContractDepositReleasePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Lr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgreementDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgreementDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Rr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgreementDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, zr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBlankContractDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBlankContractDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Br = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBlankContractDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Vr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyers(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Hr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyers", e] });
	}, e[0] = t, e[1] = n), n;
}, Ur = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersAgent", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersAgent(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Wr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersAgent", e] });
	}, e[0] = t, e[1] = n), n;
}, Gr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetBuyersSolicitor", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetBuyersSolicitor(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Kr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetBuyersSolicitor", e] });
	}, e[0] = t, e[1] = n), n;
}, qr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Jr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Yr = (e, t, n, i, a, s, c, l, d, f, p) => {
	let m = r(31), h = p === void 0 ? !0 : p, g = o(Q), _;
	m[0] !== c || m[1] !== e || m[2] !== s || m[3] !== n || m[4] !== l || m[5] !== i || m[6] !== a || m[7] !== d || m[8] !== f || m[9] !== t ? (_ = [
		"staffGetCampaignDashboard",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d,
		f
	], m[0] = c, m[1] = e, m[2] = s, m[3] = n, m[4] = l, m[5] = i, m[6] = a, m[7] = d, m[8] = f, m[9] = t, m[10] = _) : _ = m[10];
	let v = _, y;
	m[11] !== c || m[12] !== e || m[13] !== g || m[14] !== s || m[15] !== n || m[16] !== l || m[17] !== i || m[18] !== a || m[19] !== d || m[20] !== f || m[21] !== t ? (y = (r) => {
		let { signal: o } = r;
		return g.staffGetCampaignDashboard(e, t, n, i, a, s, c, l, d, f, o);
	}, m[11] = c, m[12] = e, m[13] = g, m[14] = s, m[15] = n, m[16] = l, m[17] = i, m[18] = a, m[19] = d, m[20] = f, m[21] = t, m[22] = y) : y = m[22];
	let b = h && !!g, x;
	m[23] !== v || m[24] !== y || m[25] !== b ? (x = {
		queryKey: v,
		queryFn: y,
		enabled: b
	}, m[23] = v, m[24] = y, m[25] = b, m[26] = x) : x = m[26];
	let { data: S, isPending: C, isError: w } = u(x), T;
	return m[27] !== S || m[28] !== w || m[29] !== C ? (T = {
		data: S,
		isPending: C,
		isError: w
	}, m[27] = S, m[28] = w, m[29] = C, m[30] = T) : T = m[30], T;
}, Xr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l, u) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetCampaignDashboard",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l,
			u
		] });
	}, e[0] = t, e[1] = n), n;
}, Zr = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCampaignOverview", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCampaignOverview(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Qr = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCampaignOverview", e] });
	}, e[0] = t, e[1] = n), n;
}, $r = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetCommissionInfoForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetCommissionInfoForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ei = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetCommissionInfoForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, ti = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContract", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContract(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ni = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContract", e] });
	}, e[0] = t, e[1] = n), n;
}, ri = (e, t, n, i, a, s, c, l) => {
	let d = r(25), f = l === void 0 ? !0 : l, p = o(Q), m;
	d[0] !== s || d[1] !== e || d[2] !== n || d[3] !== i || d[4] !== c || d[5] !== t || d[6] !== a ? (m = [
		"staffGetContractDashboard",
		e,
		t,
		n,
		i,
		a,
		s,
		c
	], d[0] = s, d[1] = e, d[2] = n, d[3] = i, d[4] = c, d[5] = t, d[6] = a, d[7] = m) : m = d[7];
	let h = m, g;
	d[8] !== s || d[9] !== e || d[10] !== p || d[11] !== n || d[12] !== i || d[13] !== c || d[14] !== t || d[15] !== a ? (g = (r) => {
		let { signal: o } = r;
		return p.staffGetContractDashboard(e, t, n, i, a, s, c, o);
	}, d[8] = s, d[9] = e, d[10] = p, d[11] = n, d[12] = i, d[13] = c, d[14] = t, d[15] = a, d[16] = g) : g = d[16];
	let _ = f && !!p, v;
	d[17] !== h || d[18] !== g || d[19] !== _ ? (v = {
		queryKey: h,
		queryFn: g,
		enabled: _
	}, d[17] = h, d[18] = g, d[19] = _, d[20] = v) : v = d[20];
	let { data: y, isPending: b, isError: x } = u(v), S;
	return d[21] !== y || d[22] !== x || d[23] !== b ? (S = {
		data: y,
		isPending: b,
		isError: x
	}, d[21] = y, d[22] = x, d[23] = b, d[24] = S) : S = d[24], S;
}, ii = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDashboard",
			e,
			n,
			r,
			i,
			a,
			o,
			s
		] });
	}, e[0] = t, e[1] = n), n;
}, ai = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDates",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDates(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, oi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDates",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, si = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractDeposits",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractDeposits(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ci = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractDeposits",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, li = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetContractSettlement",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetContractSettlement(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ui = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetContractSettlement",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, di = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetContractsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetContractsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetContractsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, pi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetDocumentsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetDocumentsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, mi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetDocumentsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, hi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetExternalConjunction", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetExternalConjunction(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, gi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetExternalConjunction", e] });
	}, e[0] = t, e[1] = n), n;
}, _i = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffGetFormConfiguration(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffGetFormConfiguration: u,
		staffGetFormConfigurationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, vi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetLaunchDateDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetLaunchDateDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, yi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetLaunchDateDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, bi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPhotosAndMediaDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPhotosAndMediaDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, xi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPhotosAndMediaDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Si = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ci = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, wi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPropertyInformationProgressForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPropertyInformationProgressForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ti = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPropertyInformationProgressForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ei = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSaleInformation",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSaleInformation(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Di = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSaleInformation",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Oi = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetSpecialConditions",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetSpecialConditions(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ki = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetSpecialConditions",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Ai = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetTenancyInformationForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetTenancyInformationForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ji = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetTenancyInformationForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Mi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ni = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, Pi = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["staffGetVendorDetailsForCampaign", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetVendorDetailsForCampaign(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Fi = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetVendorDetailsForCampaign", e] });
	}, e[0] = t, e[1] = n), n;
}, Ii = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffPreviewLinkedDates(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffPreviewLinkedDates: u,
		staffPreviewLinkedDatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Li = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSaveForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSaveForm: u,
		staffSaveFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ri = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(Q), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"staffSearchForCampaign",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.staffSearchForCampaign(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"staffSearchForCampaign",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, zi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffSubmitForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffSubmitForm: u,
		staffSubmitFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Bi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateAgreementDetailsForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateAgreementDetailsForCampaign: u,
		staffUpdateAgreementDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Vi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateBlankContractDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBlankContractDetailsForCampaign: u,
		staffUpdateBlankContractDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Hi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyers(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyers: u,
		staffUpdateBuyersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ui = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyersAgent(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyersAgent: u,
		staffUpdateBuyersAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Wi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateBuyersSolicitor(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateBuyersSolicitor: u,
		staffUpdateBuyersSolicitorPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Gi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateCommissionInfoForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateCommissionInfoForCampaign: u,
		staffUpdateCommissionInfoForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ki = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractComplianceFields(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractComplianceFields: u,
		staffUpdateContractComplianceFieldsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, qi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractDates(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractDates: u,
		staffUpdateContractDatesPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ji = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractDeposits(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractDeposits: u,
		staffUpdateContractDepositsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Yi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractSettlement(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSettlement: u,
		staffUpdateContractSettlementPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Xi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateContractSpecialConditionDueDate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSpecialConditionDueDate: u,
		staffUpdateContractSpecialConditionDueDatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Zi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { contractId: t, body: n } = e;
		return a.staffUpdateContractSpecialConditions(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractSpecialConditions: u,
		staffUpdateContractSpecialConditionsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Qi = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateContractTermination(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateContractTermination: u,
		staffUpdateContractTerminationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $i = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateExternalConjunction(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateExternalConjunction: u,
		staffUpdateExternalConjunctionPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ea = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateLaunchDateForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateLaunchDateForCampaign: u,
		staffUpdateLaunchDateForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ta = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdatePhotosAndMediaDetailsForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdatePhotosAndMediaDetailsForCampaign: u,
		staffUpdatePhotosAndMediaDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, na = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdatePropertyDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdatePropertyDetailsForCampaign: u,
		staffUpdatePropertyDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ra = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, contractId: n, body: r } = e;
		return a.staffUpdateSaleInformation(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateSaleInformation: u,
		staffUpdateSaleInformationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ia = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateServiceFeeInfoForCampaign(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateServiceFeeInfoForCampaign: u,
		staffUpdateServiceFeeInfoForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, aa = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateTenancyInformationForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateTenancyInformationForCampaign: u,
		staffUpdateTenancyInformationForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, oa = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { campaignId: t, body: n } = e;
		return a.staffUpdateVendorDetailsForCampaign(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateVendorDetailsForCampaign: u,
		staffUpdateVendorDetailsForCampaignPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, sa = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.submitForm(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		submitForm: u,
		submitFormPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { m as AddressSearchStateToSearch, h as AdjustmentCommissionType, g as AdjustmentToCommissionCondition, _ as AgreementType, v as AlertType, y as AndOr, b as AustralianState, x as BasicCampaignDetailsModelStage, S as BasicCampaignDetailsModelState, C as BeginCampaignState, w as BlankContractStatuses, T as BodyCorporateType, ee as BuiltOnOrVacantLandType, te as CampaignActionRequestCampaignAction, ne as CampaignAdminModelMarketingStatus, re as CampaignAdminModelStage, ie as CampaignAdminModelState, ae as CampaignCompletionStateCompletionType, oe as CampaignDashboardLaunchStatus, se as CampaignDashboardRowMarketingStatus, E as CampaignDetailModelBlankSalesContractStatus, D as CampaignDetailModelStage, O as CampaignDetailModelState, k as CampaignSearchResultStage, A as CampaignStatuses, Q as CampaignsApiContext, q as CampaignsApiException, rr as CampaignsApiProvider, p as CampaignsClient, Y as CampaignsRoute, j as Chattel, M as Chattels, N as CommissionDetailsChangeInfoChangeType, P as CommissionTypes, F as CommunityTitlesSchemeDocumentType, I as ComparativeType, L as Condition, R as ConditionType, z as ConditionalTextInputType, B as ContractActionRequestContractAction, V as ContractCompletionType, H as ContractConditionType, U as ContractDashboardRowVendorBankDetailsStatus, W as ContractDatesConditionConfigContractDateType, G as ContractDepositReleaseAvailabilityState, K as ContractStatuses, ce as ContractType, le as CoolingOffCondition, ue as CoolingOffType, de as CustomPdfScript, fe as DayType, pe as DepositPayable, me as DepositPaymentType, he as DepositType, ge as DevCreateContractTestCampaignRequestAgreementSource, _e as DevCreateContractTestCampaignRequestContract, ve as DevCreateContractTestCampaignRequestContractConditions, ye as DevCreateContractTestCampaignRequestContractCreationSource, be as DevCreateContractTestCampaignRequestContractStage, xe as DevCreateContractTestCampaignRequestCreateFrom, Se as DevCreateContractTestCampaignRequestDepositProfile, Ce as DevCreateContractTestCampaignRequestListingLaunch, we as DevCreateContractTestCampaignRequestState, Te as DocuSignInfoCondition, Ee as DocumentTypes, De as EditScope, Oe as EditablePdfButtonPdfFieldType, ke as EditablePdfButtonType, Ae as EditablePdfUploadCustomScript, je as EditablePdfUploadDocumentType, Me as ElementType, Ne as EmploymentType, Pe as EnvelopeSubmissionModelStatus, Fe as EnvelopeSubmissionModelType, Ie as EnvelopeSubmissionRecipientStatus, Le as ExternalConjunctionConjunctionFeeType, Re as FileUploadDocumentType, ze as FlatCommissionType, Be as FormConfigurationRequestFormType, Ve as FormDetailsFlow, He as FormDetailsState, Ue as FormDetailsType, We as FormPageActionButtonType, Ge as FormPageSubmitType, Ke as FormState, qe as FormSubmissionRequestFormType, Je as FormSubmissionRequestState, Ye as FormType, Xe as IdentityDocument, Ze as IdentityVerificationDocumentSighted, Qe as IdentityVerificationExportsAggregateStatus, $e as IdentityVerificationExportsModelAggregateStatus, et as IdentityVerificationProofOfOwnershipDocument, tt as InProgressFormModelFormType, nt as IsoDayOfWeek, rt as LandAreaType, it as LaunchDateDetailsStatus, at as LaunchDateStatus, ot as LaunchDateStatuses, st as LaunchDetailsStatus, ct as LegalOwnershipDocument, lt as LinkedDateImpactSourceDateType, ut as MarketingStatuses, dt as NoCoolingOffReason, ft as NswContractRequestModelDisplaySalePriceOnceSold, pt as NswContractSubmissionModelDisplaySalePriceOnceSold, mt as NswListingGeneratorModelVendorWaivingCoolingOffPeriod, ht as NswListingSubmissionModelHasContractAlreadyBeenRequested, gt as Operator, _t as OwnerBuilderDeclarationCustomScript, vt as OwnerBuilderDeclarationDocumentType, yt as OwnershipStructure, bt as PageStatusStatus, xt as PlaceOfIssue, St as PoolDocumentationType, Ct as PoolSafetyFileType, wt as QldContractRequestModelAcquiringLandForTaxPurpose, Tt as QldContractRequestModelDisplayTenantDetailsOnContract, Et as QldContractRequestModelIncludeBuyerDetailsOnContract, Dt as QldContractRequestModelIncludeVendorDetailsOnContract, Ot as QldContractSubmissionModelDisplaySalePriceOnceSold, kt as QldListingSubmissionModelApprovedSafetySwitchInstalled, At as QldListingSubmissionModelCompliesWithSmokeAlarmLegislation, jt as QldListingSubmissionModelGstIsPaymentRequired, Mt as QldListingSubmissionModelIncludeVendorDetailsOnContract, Nt as QldListingSubmissionModelNeighbourhoodDisputes, Pt as QueenslandBlankContractModelApprovedSafetySwitchInstalled, Ft as QueenslandBlankContractModelCompliesWithSmokeAlarmLegislation, It as QueenslandBlankContractModelGstIsPaymentRequired, Lt as QueenslandBlankContractModelIncludeVendorDetailsOnContract, Rt as QueenslandBlankContractModelNeighbourhoodDisputes, zt as QueenslandListingGeneratorModelApprovedSafetySwitchInstalled, Bt as QueenslandListingGeneratorModelCompliesWithSmokeAlarmLegislation, Vt as QueenslandListingGeneratorModelNeighbourhoodDisputes, Ht as ReasonForTransaction, Ut as RenderedSpecialConditionConditionType, Wt as RentPeriod, Gt as RuralType, Kt as SaleDetailsState, qt as SaleType, Jt as SecondaryIdentityDocument, Yt as SecondaryIdentityDocuments, Xt as SellersDisclosurePreparedBy, Zt as SellersDisclosurePreparedByModelPreparedBy, Qt as SellersDisclosureUploadCustomScript, $t as SellersDisclosureUploadDocumentType, en as SendForDocuSigningType, tn as SendFormSubmissionModelFormType, nn as SendFormSubmissionModelState, rn as ServiceFeeDetailsChangeInfoChangeType, an as SettlementDateStatuses, on as SignboardRemovalRemovalType, sn as SignboardRemovalType, cn as SigningOrderGroups, ln as SolicitorType, un as SortingOption, dn as SortingOptionContractDashboard, fn as SpecialConditionBankTemplateConditionType, pn as SpecialConditionDataConditionType, mn as StaffBeginCampaignRequestState, hn as StaffContractDepositReleaseDestinationOfTransfer, gn as StaffCreateContractDepositReleaseRequestDestinationOfTransfer, _n as StaffGetBlankContractDetailsForCampaignResponseBlankSalesContractStatus, vn as StaffGetCampaignOverviewResponseVendorCommunicationPreference, yn as StaffGetCommissionInfoForCampaignModelPartnershipLevel, bn as StaffGetContractSettlementResponseSettlementType, xn as StaffGetSaleInformationResponseSaleMethod, Sn as StaffGetSaleInformationResponseUnconditionalDisplayAs, Cn as StaffGetSaleInformationResponseUnderOfferDisplayAs, wn as StaffPreviewLinkedDatesRequestSourceDateType, Tn as StaffUpdateBlankContractDetailsForCampaignRequestBlankSalesContractStatus, En as StaffUpdateCommissionInfoForCampaignRequestChangeType, Dn as StaffUpdateContractSettlementRequestSettlementType, On as StaffUpdateContractTerminationRequestContractTerminationReasons, kn as StaffUpdateContractTerminationRequestDepositEntitlement, An as StaffUpdateLaunchDateForCampaignRequestStatus, jn as StaffUpdateSaleInformationRequestSaleMethod, Mn as StaffUpdateSaleInformationRequestUnconditionalDisplayAs, Nn as StaffUpdateSaleInformationRequestUnderOfferDisplayAs, Pn as StaffUpdateServiceFeeInfoForCampaignRequestChangeType, Fn as StakeholderType, In as States, Ln as SurveyPlanUploadDocumentType, Rn as TenancyModelTerm, zn as TenancyTerm, Bn as TenancyType, Vn as TieredSystemType, Hn as TimeUnit, Un as TypedFormDocumentModelDocumentType, Wn as UploadedDocumentDocumentType, Gn as UploadedDocumentInfoDocumentType, Kn as UploadedDocumentInfoSigningMethod, qn as UploadedPOADocumentModelDocumentType, Jn as ValueType, Yn as VendorBankDetailsStatuses, Xn as VendorBuyerType, Zn as VendorBuyerTypes, Qn as VendorCommPreference, $n as VerificationMethod, er as YesNoQuestion, ir as useAddOrUpdateDocument, ar as useBeginCampaign, Z as useCampaignsClientContext, or as useCompleteCampaignStep, sr as useConstructConditionClauseText, cr as useDevCreateContractTestCampaign, lr as useExchangeContract, ur as useFormsByLocations, dr as useGetActiveCampaigns, pr as useGetArchivedCampaignsByAdmin, hr as useGetArchivedCampaignsByAgency, _r as useGetCampaign, yr as useGetCampaignsForAgency, xr as useGetSpecialConditionBank, Cr as useGetUploadedFileLink, fr as useInvalidateUseGetActiveCampaigns, mr as useInvalidateUseGetArchivedCampaignsByAdmin, gr as useInvalidateUseGetArchivedCampaignsByAgency, vr as useInvalidateUseGetCampaign, br as useInvalidateUseGetCampaignsForAgency, Sr as useInvalidateUseGetSpecialConditionBank, wr as useInvalidateUseGetUploadedFileLink, Er as useInvalidateUseLoadForm, Rr as useInvalidateUseStaffGetAgreementDetailsForCampaign, Br as useInvalidateUseStaffGetBlankContractDetailsForCampaign, Hr as useInvalidateUseStaffGetBuyers, Wr as useInvalidateUseStaffGetBuyersAgent, Kr as useInvalidateUseStaffGetBuyersSolicitor, Jr as useInvalidateUseStaffGetCampaign, Xr as useInvalidateUseStaffGetCampaignDashboard, Qr as useInvalidateUseStaffGetCampaignOverview, ei as useInvalidateUseStaffGetCommissionInfoForCampaign, ni as useInvalidateUseStaffGetContract, ii as useInvalidateUseStaffGetContractDashboard, oi as useInvalidateUseStaffGetContractDates, ci as useInvalidateUseStaffGetContractDeposits, ui as useInvalidateUseStaffGetContractSettlement, fi as useInvalidateUseStaffGetContractsForCampaign, mi as useInvalidateUseStaffGetDocumentsForCampaign, gi as useInvalidateUseStaffGetExternalConjunction, yi as useInvalidateUseStaffGetLaunchDateDetailsForCampaign, xi as useInvalidateUseStaffGetPhotosAndMediaDetailsForCampaign, Ci as useInvalidateUseStaffGetPropertyDetailsForCampaign, Ti as useInvalidateUseStaffGetPropertyInformationProgressForCampaign, Di as useInvalidateUseStaffGetSaleInformation, ki as useInvalidateUseStaffGetSpecialConditions, ji as useInvalidateUseStaffGetTenancyInformationForCampaign, Ni as useInvalidateUseStaffGetUploadedFileLink, Fi as useInvalidateUseStaffGetVendorDetailsForCampaign, $ as useInvalidateUseStaffSearchForCampaign, Tr as useLoadForm, Dr as useNegotiate, Or as usePerformCampaignAction, kr as usePerformContractAction, Ar as useRemoveFile, jr as useRemoveFormSubmission, Mr as useSaveForm, Nr as useSendForm, Pr as useSetCampaignOwnership, Fr as useStaffBeginCampaign, Ir as useStaffCreateContractDepositRelease, Lr as useStaffGetAgreementDetailsForCampaign, zr as useStaffGetBlankContractDetailsForCampaign, Vr as useStaffGetBuyers, Ur as useStaffGetBuyersAgent, Gr as useStaffGetBuyersSolicitor, qr as useStaffGetCampaign, Yr as useStaffGetCampaignDashboard, Zr as useStaffGetCampaignOverview, $r as useStaffGetCommissionInfoForCampaign, ti as useStaffGetContract, ri as useStaffGetContractDashboard, ai as useStaffGetContractDates, si as useStaffGetContractDeposits, li as useStaffGetContractSettlement, di as useStaffGetContractsForCampaign, pi as useStaffGetDocumentsForCampaign, hi as useStaffGetExternalConjunction, _i as useStaffGetFormConfiguration, vi as useStaffGetLaunchDateDetailsForCampaign, bi as useStaffGetPhotosAndMediaDetailsForCampaign, Si as useStaffGetPropertyDetailsForCampaign, wi as useStaffGetPropertyInformationProgressForCampaign, Ei as useStaffGetSaleInformation, Oi as useStaffGetSpecialConditions, Ai as useStaffGetTenancyInformationForCampaign, Mi as useStaffGetUploadedFileLink, Pi as useStaffGetVendorDetailsForCampaign, Ii as useStaffPreviewLinkedDates, Li as useStaffSaveForm, Ri as useStaffSearchForCampaign, zi as useStaffSubmitForm, Bi as useStaffUpdateAgreementDetailsForCampaign, Vi as useStaffUpdateBlankContractDetailsForCampaign, Hi as useStaffUpdateBuyers, Ui as useStaffUpdateBuyersAgent, Wi as useStaffUpdateBuyersSolicitor, Gi as useStaffUpdateCommissionInfoForCampaign, Ki as useStaffUpdateContractComplianceFields, qi as useStaffUpdateContractDates, Ji as useStaffUpdateContractDeposits, Yi as useStaffUpdateContractSettlement, Xi as useStaffUpdateContractSpecialConditionDueDate, Zi as useStaffUpdateContractSpecialConditions, Qi as useStaffUpdateContractTermination, $i as useStaffUpdateExternalConjunction, ea as useStaffUpdateLaunchDateForCampaign, ta as useStaffUpdatePhotosAndMediaDetailsForCampaign, na as useStaffUpdatePropertyDetailsForCampaign, ra as useStaffUpdateSaleInformation, ia as useStaffUpdateServiceFeeInfoForCampaign, aa as useStaffUpdateTenancyInformationForCampaign, oa as useStaffUpdateVendorDetailsForCampaign, sa as useSubmitForm };
